
<div
  :id="content.idHTML"
  :class="[jel_getClassObject(content), content.theme ? content.theme : 'themeClair']"
  class="entete-section position-relative couleur-section-debut"
  :style="{
    '--couleurSection': content.couleurSection,
    '--couleurSectionDebut': content.couleurSectionDebut,
  }"
>
  <div :class="content.imagePleineLargeur === 'true' ? 'contenu-pleine-largeur' : 'contenu'">
    <div class="position-relative img-gradient mx-auto image mb-2">
      <MediaImageFocalPoint :content="contentMediaImage" />
      <b-row class="restreindre-largeur m-auto">
        <div class="boite-texte mx-md-auto px-2 pl-sm-3 px-xl-4">
          <div
            class="texte-information position-relative"
            :class="
              content.theme
                ? content.theme == 'themeClair'
                  ? 'themeFonce'
                  : 'themeClair'
                : 'themeFonce'
            "
          >
            <Titre :content="contentSurTitre" />
            <p class="titre-entete pb-0 mb-1" v-html="content.titre" />
            <div class="sous-titre" v-html="content.sousTitre" />
            <span @click.capture="gaPreventClick">
              <Hyperlien :content="contentBouton" />
            </span>
          </div>
        </div>
      </b-row>
    </div>
    <div v-if="content.afficherDegrade == 'true'" class="degrade position-absolute w-100" />
  </div>
  <div
    class="couleur-section"
    :class="{ 'restreindre-largeur': content.restreindreLargeur === 'true' }"
  >
    <EditableArea
      :content="content.enteteSection"
      :parentTemplateId="metadata['mgnl:template']"
    />
  </div>
</div>
